import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  local: "ar",
  locale: "ar",
  fallbackLocale: "ar",
  silentTranslationWarn: true,
  messages: {
    /* english language */
    en: {
      auth: {
        register_msg: "Register New Account",
        welcome_msg: "Welcome Dear Visitor!",
        login_msg: "Please login to your account.",
        personal_info: " Personal Information",

        donate_by: "Donate By",

        resend_verify_code: "Resend Verification code",
        login: "Login",
        register: "Register",
        forget_password: "Forget password",
        reset_password: "Reset your password",
        remember_me: "Remember me",
        no_account: "Not member",
        forget_button: "Reset password",
        not_member: "Not member",
        enter_email: "Enter your email address",
        email: "Email address",
        password: "Password",
        confirm_password: "Confirm password",
        new_password: "New Password",
        new_confirm_password: "Confirm New Password",
        update_password: "Update Password",
        first_name: "First Name",
        last_name: "Last Name",
        mobile: "Mobile",
        id_number: "ID Number",
        has_account: "already have account ?",
        token: "Token",
        save: "Save",
        profile: "My Profile",
        shares: "My Shares",
        shared: "Shared",
        link: "Link",
        copy_link: "Copy Link",
        visitors: "Visitors",
        total_donations: "Total Donations",
        noShares: "No Shares",
        logout: "Logout",

        verify_account: "Verify Account",
        verification_code: "Verification Code",
        verify: "Verify",
      },

      donationVoucher: {
        title: "Donation Vouchers",
        donation_voucher_value: "donation voucher value",
        from_name: "From Name",
        to_name: "To Name",
        choose_template: "Choose Template",
      },

      app: {
        payment_status_error: "Payment is un available now ",
        va_name: "Name is required",
        va_email: "Email is required",
        va_mobile: "Mobile is required",
        va_subject: "Message is required",
        allRequired: "All fields are required",
        notes: "Notes",

        donate_before_msg: "Donated before",

        send_msg: "Send Message Successfully",
        add_msg: "added to cart successfully",
        add_fail: "failed to add to cart",
        deleted_msg: "deleted successfully",

        email_msg: "email sent successfully",

        email_msg_failed: "failed to send email",

        share_msg: "create share link successfully",
        share_msg_failed: "failed to create share link, copied before",

        send_code_msg: " send code successfully",
        send_code_msg_failed: " failed to send code",
        send_code_msg2: "Verify email successfully",
        enter_data_required: " Please enter required data ",

        send_code_msg2_failed: " failed to verify email",

        reset_msg: " reset password successfully",
        reset_msg_failed: " code is not valid",

        register_msg: " create account successfully",
        register_msg_failed: " failed to create account",

        error_contact_us: "Error, Data is not valid",
        error_phone_required: "error, phone number required",
        years: "Years",
        threeYears: "Years",
        expYears: "Years",

        donate_Now: "Donate Now",
        the_cart: "Cart",

        charity_work: "Charity Work",
        count1: "donation process",
        count2: "orphan sponsorship",
        count3: "donors",
        count4: "projects",
        donation_values_types: "Choose Type and Amount of Donation",
        contactUsToDonate: "Contact Us To Donate",

        about_msg: "Pure charitable work for the sake of God is our goal",
        about1: "Children's education",
        about2: "look far",
        about3: "Helping the needy",
        about4: "What does the association offer?",
        about5: "The latest news of the association",
        about6: "general news",

        directors: "Board of Directors",
        volunteerRequest: "Volunteer Request",
        donationVouchers: "Donation Vouchers",
        request: "Request",

        charity_work_big: "We have a group of volunteers in charitable work",

        mission: "Missions",
        vision: "Vision",

        kwd: "KWD",
        collect: "Collected",

        change_lang: "Language",
        arabic: "Arabic",
        english: "English",
        contact: "Contact",
        appear: "Show",
        dinar: "KWD",
        kiwaty: "Kiwaty",
        share: "Share",
        project: "Project",
        enter_Amount: "Or Enter Amount",
        enterAmount: "Enter Amount",

        past_donations: "Previous Donations",
        home: "Home",
        orphans: "Orphans",
        projects: "Projects",
        donators: "Dontors",
        kflah_orphans: "Kflah Orphans",
        endowments: "Endowments",
        news: "News",
        achievements: "Achievements",
        about: "About",
        about_munhaj: "About Us",
        preachers: "Preachers",
        gallery: "Gallery",
        videos: "Video",
        contacts: "Contacts",
        contact_us: "Contact Us",
        carts: "Carts",

        calcluate_zahat: "Calculate Zakaah",
        cart: "Cart",
        search: "Search",
        search_via_name: "Search name..",

        name: "Name",
        email: "Email Address",
        mobile: "Mobile",
        body: "Body",
        send: "Send",

        alert: "Alert",
        eid_services: "Eid Orphan",
        enter_month: "Enter the month",
        enter_amountـeid: "Please enter the amount",
        month: "Month",
        total: "Total",
        note_via_month: "Amount of monthly donation(15 kwd)",
        donation_month_amount: "Amount of donation",

        show: "Show",
        orphan_search: "Orphan Search",
        loading: "Loading...",
        donation_now: "Donate Now",
        more_to_us: "More",
        more: "More",
        know_more: "Know More",
        general_donation: "General Donation",
        donation_types: "Choose Donation Type",
        donation_values: "Choose Donation Amount",
        or_donations_all: "Or Donations All Amount",
        enter_amount: "Other Amounts",
        enter_donation: "Enter donation amount",
        or: "Or",
        kw: "KWD",
        add_to_cart: "Add To Cart",
        our_projects: "Current Projects",
        our_thumbs: "The importance of donating",

        start_date: "Start Date",
        view: "View",
        donate: "Donate",
        no_data: "No data",

        categories: "Categories",
        mongezProjects: "Completed Projects",
        notMongezProjects: "Projects in progress",
        completedProjects: "Completed Projects",
        notCompletedProjects: "Projects in progress",
        choose_category: "Choose Category",
        choose_country: "Choose Country",
        choose_volunteer_type: "Choose Volunteer Types",
        choose_city: "Choose City",
        choose_deduction: "Choose Deduction",
        choose_value: "Choose Value",
        projects_count: "Total Projects",
        projectNomination: "Project Nomination",
        volunteerRequest: "Volunteer Request",
        nominationValue: "Amount",
        fill_form: "Fill the form",

        fill_deduction: "Fill Deduction",
        deduction_dawry: "Donate my turn",
        deduction_duraiton: "Donate Duration",
        deduction_type: "Deduction Type",
        daily: "Daily",
        weekly: "Weekly",
        everyFriday: "Every Friday",
        monthly: "Monthly",
        sixmonth: "6 Month",
        year: "Year",
        twoYears: "2 Years",
        conitnue: "For live",

        paid: "Paid",
        paidMoney: "Paid Amount",
        remain: "Remain",
        remainMoney: "Remain Amount",

        getting: "Paid",
        target: "Target",

        watch_video: "View video",

        about_orphans: "About",
        reward_orphans: "Reward Sponsoring Orphans",
        ways_orphans: "Ways to Sponsor Orphans",

        take_orphans: "Sponsor an orphan",
        choose_search: "Choose Search",
        search_with_dots: "Search...",
        calculate_zakaah: "Calculate Zakaah",
        amount_of_zakaah_is: "Amount of zakaah is ",

        urgent_relief: "Urgent Relief",
        support_and_relief: "Support and relief",
        building_hospitals_and_medical_centers:
          "Building hospitals and medical centers",
        performing_urgent_surgical_operations:
          "Performing urgent surgical operations",
        providing_medical_equipment: "Providing medical equipment",
        support_and_care: "Support and care",
        providing_medicines: "Providing medicines",
        providing_and_replacing_heart_devices:
          "Providing and replacing heart devices",
        conducting_examinations_and_diagnosis:
          "Conducting examinations and diagnosis",
        performing_surgical_operations: "Performing surgical operations",
        support_and_care_for_children_with_heart_disease:
          "Support and care for children with heart disease",
        zakat_and_charity: "Zakat and charity",
        general_sustainability_endowment: "General sustainability endowment",
        childrens_heart_endowment: "Children's heart endowment",
        services: "Services",
        design_a_project: "Design a project",
        dedicate_a_donation: "Dedicate a donation",
        volunteer_request: "Volunteer request",
        zakat_calculator_in_the_header_and_here_as_well:
          "Zakat calculator in the header and here as well",
        zakat_calculator: "Zakat calculator",
        about_charity: "About charity",
        about_us: "About charity",
        basic_system: "Basic system",
        board_of_directors: "Board of Directors",
        zakat_and_charity_funds: "Zakat and charity funds",
      },

      cart: {
        title: "Donation Cart",
        payment_method: "Payment Method",
        donation_info: "Donor Info",
        donation_option: "Donation Option",
        good_man: "Benefactor",
        good_man_detail:
          "By making a good donation, your data will not appear in your donation",

        want_email: 'I would like to receive a "Donation Receipt" to the email',
        want_email_detail:
          'The "donation receipt" is the only reference in case you have any questions or request assistance regarding the donation process',

        email: "Email address",
        name: "Name",
        mobile: "Mobile",
        submit: "Submit",
        go_to_payment: "Go To payment page",
        pay_now: "Pay Now",

        project_name: "Project Name",
        total_grand: "Total Grand:",
        nodata: "There are no projects found.",
        view_all: "View Projects",
        currency: "KWD",
      },

      counter: {
        projects: "Projects",
        clients: "Donors",
        orphans: "Project countries",
        donations: "Donations",
      },

      header: {
        home: "Home",
        news: "News",
        projects: "Projects",
        orphans: "Orphans",
        preachers: "Preachers",
        reliefs: "Reliefs",
        endowments: "Endowments",
        about_us: "About charity",
        testimonials: "Testimonials",
        brief: "About the association",
        gallery: "Gallery",
        teams: "Teams",
        multimedia: "Multimedia",
        contact_us: "Contact us",
        contact: "Contact",
        deductions: "Dudections",
        urgent: "Urgent",
        postgraduates: "Postgraduates",
      },

      home: {
        title: "Home",
        achievement: "Achievements",
        our_mission: "Our Mission",
        our_vision: "Our Vision",
        our_goal: "Our Goals",
        general_brief: "General Brief",
      },

      project: {
        detail: "Description",
        goals: "Goals",
        achievements: "Achievements",
        files: "PDF Files",
        videos: "Videos",
        download_file: "Download File",
        watch_video: "View Video",
        share: "Share",
      },

      projects: {
        all: "All",
      },

      orphan: {
        male: "Male",
        female: "Female",
        detail: "Description",
        id2: "ID Number",
        id: "ID Number",
        gender: "Gender",
        mother_name: "Mother Name",
        country: "Country",
        parents: "Parents",
        birth_date: "Birth Date",
        birth_place: "Birth Place",
        education: "Education",
        orphanage: "Orphanage",
        files: " Files",
      },

      preacher: {
        detail: "Description",
        marital_status: "Marital Status",
        qualifcations: "Qualifcations (Memorize The Quran Times)",
        job: "Job",
        job_place: "Job Place",
      },

      gallery: {
        title: "Gallery",
      },

      multimedia: {
        title: "Multimedia",
      },

      contact: {
        title: "Contact Us",
        titles: "Contact Us",
        address: "Address",
        mobile: "Mobile",
        hot_line: "Hot Line",
        phone: "Phone",
        email: "Email Address",
        name: "Name",
        subject: "Subject",
        body: "Message",
        submit: "Send",
        notes: "notes",

        stay_in_touch: "Stay in Touch",
        talk_to_us: "Don't hesitate to contact us    ",

        the_phone: " Organization Number  ",

        location: "Our Location",
        send_message: "Send your Message ",
        talk: "We are honored by your inquiries and suggestions",
      },

      country: {
        egypt: "Egypt",
        lebnan: "Lebanon",
        ksa: "Saudia arabia",
        kuwait: "Kuwait",
        ymen: "Ymen",
        sudan: "Sudan",

        somalia: "Somalia",
        niger: "Niger",
        chad: "Chad",
        palestine: "Palestine",
        syria: "Syria",
        turkey: "Turkey",
        bangladesh: "Bangladesh",
        albania: "Albania",
        bosnia_and_herzegovina: "Bosnia And Herzegovina",
        indonesia: "Indonesia",
        india: "India",
        jordan: "Jordan",
      },

      footer: {
        percentage_zero:
          "The administrative rate is 0% since the establishment of the association",

        fast_links: "Fast links",

        contact_us: "Contact Us",
        website_map: "Website map",
        services: "Services",
        latest_news: "Latest News",
        copyright:
          "All Right Reserved 2024 © Copyright Children Sheart Charity Association",

        copyright_done: "Done By ",
        copyright_company: "Gate Techs",
        privacy: "Privacy Policy",
        terms: "Terms Condition",
        search_title: "Please choose category and enter project name",
        project_name: "Project Name",
        search: "Search",
        email: "email",
        location: "location",
        phone: "phone",

        amount: "Enter charity mount",
        amount_money: "Charity amount is:",
        calculate_your_money: "Calculate charity amount",
        calculate: "Calculate",
        calculate_zakaah: "calculate zakaah",
      },
    },

    /* arabic language */
    ar: {
      auth: {
        donate_by: "تم التبرع ب",

        register_msg: "تسجيل حساب جديد",
        welcome_msg: "مرحبا بك عزيزي الزائر!",

        login_msg: "يرجى تسجيل الدخول إلى حسابك.",
        personal_info: "البيانات الشخصية",
        change_picture: "تغيير الصورة",
        register: "مستخدم جديد",
        profile: "حسابي",
        logout: "تسجيل خروج",

        resend_verify_code: "إعادة إرسال كود التفعيل",
        login: "تسجيل دخول",

        forget_password: "نسيت الرقم السري",
        reset_password: "إعادة تعيين الرقم السري",
        remember_me: "تذكرني",
        no_account: "ليس لديك حساب؟",
        forget_button: "إعادة تعيين الرقم السري",
        not_member: "ليس عضوا؟",
        enter_email: "أدخل بريدك الإلكتروني",
        email: "البريد الإلكتروني",
        password: "الرقم السري",
        confirm_password: "تأكيد الرقم السري",
        new_password: "الرقم السري الجديد",
        new_confirm_password: "تأكيد الرقم السري الجديد",
        update_password: "تعديل الرقم السري",
        first_name: "الإسم الأول",
        last_name: "الإسم الأخير",
        mobile: "رقم الجوال",
        id_number: "رقم الهوية",
        has_account: "هل لديك حساب بالفعل ؟",
        token: "الكود",
        save: "حفظ",

        shares: "وصلات المشاركة",
        shared: "الوصله",
        link: "الرابط",
        copy_link: "نسخ الرابط",
        visitors: "عدد الزيارات",
        total_donations: "إجمالي التبرعات",
        noShares: "لا يوجد وصلات",

        verify_account: "تفعيل الحساب",
        verification_code: "كود التفعيل",
        verify: "تفعيل",
      },

      donationVoucher: {
        title: "قسايم التبرعات",
        donation_voucher_value: "قيمة قسيمة الهدية",
        from_name: "اسم الراسل",
        to_name: "اسم المرسل إليه",
        choose_template: "اختر التصميم",
      },

      app: {
        payment_status_error: "الدفع غير متاح حاليا",
        va_name: "حقل الاسم مطلوب",
        va_email: "حقل البريد الإلكتروني مطلوب",
        va_mobile: "حقل رقم الجوال مطلوب",
        va_subject: "حقل الرسالة مطلوب",
        allRequired: "جميع الحقول مطلوبة",
        notes: "ملاحظات",

        donate_before_msg: "لقد قمت بالتبرع من قبل",
        add_msg: "تم إضافة إلي السلة بنجاح",
        add_fail: "خطاء عند الإضافة إلي السلة ",
        send_msg: "تم إرسال الرسالة بنجاح",

        deleted_msg: "تم الحذف بنجاح",
        email_msg: "تم إرسال رسالة إلي بريدك الإلكتروني",
        email_msg_failed: "البريد الإلكتروني غير موحود",
        share_msg: "تم إنشاء رابط مشاركة بنجاح",
        share_msg_failed: "تم نسخ الرابط مسبقا",

        send_code_msg: "تم إرسال الكود بنجاح",
        send_code_msg_failed: "لم يتم إرسال الكود",
        send_code_msg2: "تم تفعيل حسابك بنجاح",
        send_code_msg2_failed: "كود التفعيل غير صحيح",

        reset_msg: "تم تعديل كلمة المرور بنجاح",
        reset_msg_failed: "الكود غير صحيح",

        register_msg: "تم إنشاء حسابك بنجاح",
        register_msg_failed: "خطاء عند إنشاء حسابك",

        error_contact_us: "حدث خطأ , يرجى التحقق من البيانات المدخلة",
        error_phone_required: "حدث خطأ, يرجي ادخال رقم الجوال ",
        enter_data_required: " يرجي إدخال البيانات المطلوبة ",

        years: "عامين",
        threeYears: "أعوام",
        expYears: "أعوام",
        the_cart: "السلة",
        donate_Now: "تبرع الآن",
        charity_work: "أعمال خيرية",
        the_charity_work: "في العمل الخيري",

        count1: "عملية تبرع",
        count2: "كفالة اليتيم",
        count3: "المتبرعين",
        count4: "المشروعات",

        about1: "تعليم الأطفال",
        about2: "ننظر لبعيد",
        about3: " مساعدة المحتاجين",
        about4: "ماذا تقدم الجمعية ؟",
        about5: "اخر اخبار الجمعية",
        about6: "الأخبار العامة",

        about_msg: "العمل الخيري الخالص لوجه الله هو غايتنا",
        directors: "مجلس الإدارة",

        charity_work_big: "لدينا نخبة من المتطوعين في العمل الخيري",
        mission: "المهام",
        vision: "الرؤية",

        kwd: "د.ك",
        collect: "تم جمع",
        project: "مشروع",
        enter_Amount: "أو ادخل المبلغ",
        enterAmount: "أدخل المبلغ",

        share: "مشاركة",
        kiwaty: "",
        dinar: "د.ك",
        appear: "اظهر",
        change_lang: "اللغة",
        arabic: "العربية",
        english: "الإنجليزية",
        past_donations: "التبرعات السابقة",
        home: "الرئيسية",
        orphans: "الأيتام",
        projects: "المشاريع",
        donators: "المتبرعين",
        kflah_orphans: "كفالة الأيتام",
        endowments: "الوقفيات",
        news: "الأخبار",
        achievements: "الإنجازات",
        about: "عن الجمعية",
        about_munhaj: "عن المعية",
        preachers: "الدعاه",
        gallery: "معرض الصور",
        videos: "معرض الفيديوهات",
        contacts: "تواصل معنا",
        contact_us: "تواصل معنا",
        contact: "تواصل",
        carts: "سلة التبرعات",

        calcluate_zahat: "حاسبة الزكاة",
        cart: "سلة التبرعات",
        search: "بحث",
        search_via_name: "ابحث بالاسم",

        name: "الاسم",
        email: "البريد الالكتروني",
        mobile: "رقم الهاتف",
        body: "الرسالة",
        send: "إرسال",
        categories: " المشاريع",
        mongezProjects: "المشاريع المنجزة",
        notMongezProjects: "المشاريع قيد الإنجاز",
        completedProjects: "مشاريع منجزة",
        notCompletedProjects: "مشاريع قيد الإنجاز",
        volunteerRequest: "طلب التطوع",
        request: "طلب",

        alert: "تنبيه",
        eid_services: "عيدية اليتيم",
        enter_month: "أدخل عدد الشهور",
        enter_amountـeid: "أدخل مبلغ العيدية",
        month: "شهر",
        total: "الإجمالي",
        note_via_month: "قيمة التبرع الشهري ( ١٥ دينار كويتي )",
        donation_month_amount: "قيمة التبرع",

        show: "أظهر",
        orphan_search: "بحث عن أسم اليتيم",
        loading: "تحميل...",
        donation_now: "تبرع الآن",
        more_to_us: "المزيد عنا",
        more: "المزيد",
        know_more: "اعرف المزيد",
        general_donation: "التبرع العام",
        donation_types: "اختر نوع التبرع",
        donation_values: "اختر مبلغ التبرع",
        donation_values_types: "اختر نوع و مبلغ التبرع",
        or_donations_all: "التبرع بكامل المبلغ",
        enter_amount: " مبالغ آخرى",
        enter_donation: "أدخل مبلغ التبرع",
        or: "أو",
        kw: "د.ك",
        add_to_cart: "اضف إلي السلة",
        our_projects: "مشاريعنا",
        our_thumbs: "أهمية التبرع",
        contactUsToDonate: "تواصل معنا للتبرع",

        start_date: "بداية المشروع:",
        view: "مشاهدة",
        donate: " تبرع ",
        no_data: "لا يوجد",

        choose_category: "أختر القسم",
        choose_country: "أختر الدولة",
        choose_volunteer_type: "اختر نوع التطوع",
        choose_city: "أختر المدينة",
        choose_deduction: "أختر نوع الإستقطاع",
        choose_value: "أختر مبلغ التبرع ",
        projects_count: "مشروع خيرى",
        projectNomination: "صمم مشروعك",
        volunteerRequest: "طلب تطوع",
        donationVouchers: "إهداء تبرع",
        nominationValue: "مبلغ التبرع",
        fill_form: "ملئ الإستمارة",

        fill_deduction: "التبرع الدائم",

        deduction_dawry: "تبرع دوري",
        deduction_duraiton: "مدة التبرع",
        deduction_type: "نوع التبرع",
        daily: "يومي",
        weekly: "أسبوعي",
        everyFriday: "كل جمعة",
        monthly: "شهري",
        sixmonth: "ستة شهور",
        year: "سنة",
        twoYears: "سنتين",
        conitnue: "مستمر",

        paid: "المدفوع",
        paidMoney: "المدفوع",
        remain: "الباقي",
        remainMoney: "المتبقي",

        getting: "المُحَصَل",
        target: "الهدف",

        watch_video: "شاهد الفيديو",

        about_orphans: "عن الأيتام",
        reward_orphans: "ثواب كفالة اليتيم",
        ways_orphans: "طرق كفالة اليتيم",

        take_orphans: "اكفل يتيم",
        choose_search: "اختر القسم",
        search_with_dots: "بحث...",
        calculate_zakaah: "احسب الزكاه",
        amount_of_zakaah_is: "مبلغ الزكاه هو",

        urgent_relief: "إغاثات عاجلة",
        support_and_relief: "دعم وإغاثة",
        building_hospitals_and_medical_centers:
          "بناء المستشفيات والمراكز الطبية",
        performing_urgent_surgical_operations: "إجراء عمليات جراحات عاجلة",
        providing_medical_equipment: "توفير الأجهزة الطبية",
        support_and_care: "دعم ورعاية",
        providing_medicines: "توفير الأدوية ",
        providing_and_replacing_heart_devices: "توفير وتبديل أجهزة القلب",
        conducting_examinations_and_diagnosis: "إجراء الفحوصات والتشخيص ",
        performing_surgical_operations: "إجراء العمليات الجراحية",
        support_and_care_for_children_with_heart_disease:
          "دعم ورعاية الأطفال مرضى القلب",
        zakat_and_charity: "زكاة وصدقات",
        general_sustainability_endowment: "وقفية الاستدامة العامة",
        childrens_heart_endowment: "وقفية قلب الأطفال ",
        services: "خدمات",
        design_a_project: "صمم مشروع",
        dedicate_a_donation: "إهداء تبرع",
        volunteer_request: "طلب تطوع",
        zakat_calculator_in_the_header_and_here_as_well:
          "حاسبة الزكاة في الهيدر وهنا أيضا",
        zakat_calculator: "حاسبة الزكاة",
        about_charity: "عن الجمعية ",
        about_us: "عن الجمعية",
        basic_system: "النظام الأساسي",
        board_of_directors: "مجلس الإدارة",
        zakat_and_charity_funds: "أموال الزكاة والصدقات",
      },

      cart: {
        title: "سلة التبرعات",
        payment_method: "طريقة الدفع",
        donation_info: "بيانات المتبرع",

        donation_option: "خيارات التبرع",
        good_man: "تبرع فاعل خير",
        good_man_detail: "من خلال التبرع كفاعل خير لن تظهر بياناتك في تبرعك",

        want_email: "ارغب فى استقبال “إيصال التبرع” على البريد الإلكترونى",
        want_email_detail:
          "“ايصال التبرع” هو المرجع الوحيد فى حالة وجود اى استفسار لديك او طلب مساعدة بشأن عملية التبرع",

        email: "البريد الإلكترونى",
        name: "الاسم",
        mobile: "رقم الجوال",
        submit: "تنفيذ الطلب",
        go_to_payment: "أذهب إلي صفحة الدفع",
        pay_now: "ادفع الان",

        project_name: "أسم المشروع",
        total_grand: "إجمالى التبرعات :",
        nodata: "لا يوجد اي مشاريع في سلة التبرعات",
        view_all: "تصفح المشاريع",
        currency: "دينار",
      },

      counter: {
        projects: "المشروعات",
        clients: "متبرعين",
        orphans: "دول المشروعات",
        donations: "عملية تبرع",
      },

      header: {
        home: "الرئيسية",
        news: "الأخبار",
        projects: "المشاريع",
        orphans: "الأيتام",
        preachers: "الدعاه",
        reliefs: "إغاثات عاجلة",
        endowments: "الوقفيات",
        about_us: "عن الجمعية",
        testimonials: "قالو عنا",
        brief: "نبذة عن الجمعية",
        gallery: "جاليري الصور",
        teams: "مجلس الإدارة",
        multimedia: "الوسائط المتعددة",
        contact_us: "اتصل بنا",
        contact: "تواصل",
        deductions: "خدمة الإستقطاع",
        urgent: "عاجل",
        postgraduates: "الدراسات العليا",
      },

      home: {
        title: "الصفحة الرئيسية",
        achievement: "انجازتنا",
        our_mission: "مهمتنا",
        our_vision: "رؤيتنا",
        our_goal: "هدفنا",
        general_brief: "نبذة عامة",
      },

      project: {
        detail: "وصف المشروع",
        goals: "أهداف المشروع",
        achievements: "إنجازات المشروع",
        files: "الملفات المرفقة",
        videos: "الفيديوهات",
        download_file: "حمل الملف",
        watch_video: "شاهد الفيديو",
        share: "شارك",
      },

      projects: {
        all: "الكل",
      },

      orphan: {
        male: "ذكر",
        female: "انثى",
        detail: "معلومات عن الطفل",
        id2: "الرقم التسلسلي",
        id: "الرقم التعريفي",
        gender: "الجنس",
        mother_name: "أسم الأم",
        country: "الدولة",
        parents: "حالة الوالدين",
        birth_date: "تاريخ الميلاد",
        birth_place: "مكان الميلاد",
        education: "الحالة الدراسية",
        orphanage: "دار الأيتام",
        files: "الملفات المرفقة",
      },

      preacher: {
        detail: "معلومات عن الداعي",
        marital_status: "الحالة الإجتماعية",
        qualifcations: "المؤهلات (حافظ القراءن)",
        job: "الوظيفة",
        job_place: "مكان العمل",
      },

      gallery: {
        title: "جاليري الصور",
      },
      multimedia: {
        title: "الوسائط المتعددة",
      },

      contact: {
        stay_in_touch: "ابق علي تواصل",
        talk_to_us: "لا تتردد في التحدث إلينا",
        title: "تواصل معنا",
        titles: "اتصل بنا",
        address: "العنوان",
        mobile: "رقم الجوال",
        hot_line: "الخط الساخن",
        the_phone: "رقم الجمعية",
        email: "البريد الإلكتروني",
        name: "الاسم",
        subject: "موضوع الرسالة",
        body: "اكتب الرسالة",
        submit: "إرسال",
        phone: "الهاتف",
        location: "موقعنا",
        send_message: "ارسل رسالتك",
        talk: "نتشرف باستفساراتكم واقتراحاتكم",
        notes: "ملاحظات",
      },

      country: {
        egypt: "مصر",
        lebnan: "لبنان",
        ksa: "السعودية",
        kuwait: "الكويت",
        ymen: "اليمن",
        sudan: "السودان",

        somalia: "الصومال",
        niger: "النيجر",
        chad: "تشاد",
        palestine: "فلسطين",
        syria: "سوريا",
        turkey: "تركيا",
        bangladesh: "بنغلاديش",
        albania: "ألبانيا",
        bosnia_and_herzegovina: "البوسنة والهرسك",
        indonesia: "إندونيسيا",
        india: "الهند",
        jordan: "الأردن",
      },

      footer: {
        percentage_zero: "النسبة الإدارية صفر % منذ تأسيس الجمعية",
        fast_links: "روابط سريعة",
        contact_us: "معلومات التواصل",
        website_map: "خريطة الموقع",
        services: "خدمتنا",
        latest_news: "أخر الأخبار",
        copyright: "جميع الحقوق محفوظة © 2024 - جمعية قلب الاطفال الخيرية",

        copyright_done: "برمجة",
        copyright_company: "بوابة التقنية",
        privacy: "سياسة الخصوصية",
        terms: "الشروط والأحكام",
        search_title: "اختر القسم",
        project_name: "أكتب أسم المشروع",
        search: "بحث",
        email: "البريد",
        location: "موقعنا",
        phone: "الهاتف",

        amount: "ادخل مبلغ الزكاة",
        amount_money: "مبلغ زكاة المال هو :",
        calculate_your_money: "أحسب زكاة مالك",
        calculate: "حساب المبلغ",
        calculate_zakaah: "احسب الزكاه",
      },
    },
  },
});
